export default __webpack_public_path__ + "static/media/lock.bde8a905.svg";